import Colors from '../../../../shared/assets/style/default/color';
import Props from '../../../../shared/types/props/splash';
import styled from 'styled-components';
import withAnimation from '../../../../shared/components/utils/hoc/withAnimation';

const PauseAdContainer = styled.div<Props>`
  background: ${Colors.background};
  display: flex;
  height: 100vh;
  justify-content: center;
  position: absolute;
  width: 100vw;
  z-index: 2;
`;

export default withAnimation(PauseAdContainer);
